import React, {useEffect, useState} from 'react';
import './App.css';
import {RouterProvider} from "react-router-dom";
import {ToastContainer} from "react-toastify";
import {adminRoutes} from "./navigation/admin";
import SessionStorage from "./store/session";
import {authRoutes} from "./navigation/auth-route";
import BlockUI from "./components/block-ui";
import {BlockUIProvider} from "./shared/services/block-ui-service";
import {managerRoutes} from "./navigation/manager";

function App() {
    const [profile, setProfile] = useState<string>();
    const [username, setUsername] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    console.log("ENV: "+process.env.NODE_ENV)
    useEffect(() => {
        async function updateSessionUser() {
            try {
                SessionStorage.getSession().then(user => {
                    if (!user) return
                    const isLogged = user?.isLogged;
                    if (!isLogged) return
                    setProfile(user?.userData?.profile)
                    setUsername(user?.userData?.firstName)
                })
            } catch (e) {
            }
        }

        updateSessionUser()
    }, [SessionStorage])
    return (

        <BlockUIProvider>
            <RouterProvider router={!profile ? authRoutes
                : profile === 'Admin' ? adminRoutes(profile, !!profile, username)
                    : profile === 'Manager' ? managerRoutes(profile, !!profile, username)
                        : authRoutes}></RouterProvider>
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"/>
            <BlockUI active={loading}/>
        </BlockUIProvider>
    );
}

export default App;
